import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';
import { appPath } from 'util/routingConfig';

const routes: CustomRoute = {
	path: appPath.eventsScore.replace(appPath.events, ''),
	components: () => [],
	render: (_, children) => children,
	children: [
		{
			path: '',
			components: () => [import(/* webpackChunkName: 'eventsScore' */ './component')],
			render: ([EventsScore]) => <EventsScore />,
		},
	],
};

export default routes;
